import { colors_light } from './colors_light.js';
import { colors_dark } from './colors_dark.js';

/**
 * 将色值对象以 CSS 变量形式注入到 DOM (html / documentElement 或 body)
 * @param {'light' | 'dark'} theme 模式，默认 light
 * @param {HTMLElement} targetNode 目标节点，默认 document.documentElement (即 <html>)
 */
export function injectColorVariables(theme = 'light', targetNode = null) {
  if (typeof document === 'undefined') return;

  const node = targetNode || document.documentElement;
  const colors = theme === 'dark' ? colors_dark : colors_light;

  Object.entries(colors).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      const varName = `--${key.replace(/_/g, '-')}`;
      node.style.setProperty(varName, value);
    }
  });

  // 快捷主色与白色变量
  node.style.setProperty('--brand-primary', colors.kygreen_6);
  node.style.setProperty('--brand-hover', colors.kygreen_5);
  node.style.setProperty('--white', colors.gray_1);
}

// 自动执行默认亮色主题注入
injectColorVariables('light');

export default {
  colors_light,
  colors_dark,
  injectColorVariables
};
